import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCX4b5yMTg4h-xwS4nwC49NiKvc_EA_8q0",

  authDomain: "placementcell-8b18f.firebaseapp.com",

  projectId: "placementcell-8b18f",

  storageBucket: "placementcell-8b18f.appspot.com",

  messagingSenderId: "313037864259",

  appId: "1:313037864259:web:fcbe60298bc972147803f6",

  measurementId: "G-3YFLD9FS33",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore();
const storage = getStorage(app);

export default db;
export { app, storage };
